"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticStyles = void 0;
/**
 * Custom static styles.
 *
 * ! Avoid adding anything to this export, unless absolutely necessary.
 * ! Rather, refactor these definitions into component-specific styles.
 */
exports.staticStyles = [];
//# sourceMappingURL=static-styles.js.map